import { throttle } from "lodash"
import { Controller } from "stimulus"

import { isElementInViewport } from "../../../js/utils"

export default class extends Controller {
  static get targets() {
    return ["more"]
  }

  connect() {
    this.onScroll = throttle(this.onScroll, 200)

    this.onScroll()
  }

  onScroll() {
    if (!this.moreTarget.classList.contains("is-visible") && isElementInViewport(this.moreTarget, false)) {
      this.moreTarget.classList.add("is-visible")
    }
  }
}
